import React from "react";
import "./Notification.scss";
import { IoChevronBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Header from "../Home/Header/Header";

const Notification = () => {
  const navigate = useNavigate();

  return (
    <div className="notification_main_div">
      <Header otherPage={true} title="Notification" />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <p style={{ margin: "0px" }}>Coming Soon...</p>
      </div>
      {/* <div style={{ paddingTop: "55px",margin:'5px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <div className="notification_div">
          <div style={{ marginTop: "10px" }}>
            <p className="notification_mainTitle">Notification 1</p>
            <p className="notification_subtitle">
              This is the dummy notification.....
            </p>
          </div>
        </div>
        <div className="notification_div">
          <div style={{ marginTop: "10px" }}>
            <p className="notification_mainTitle">Notification 1</p>
            <p className="notification_subtitle">
              This is the dummy notification.....
            </p>
          </div>
        </div>
        <div className="notification_div">
          <div style={{ marginTop: "10px" }}>
            <p className="notification_mainTitle">Notification 1</p>
            <p className="notification_subtitle">
              This is the dummy notification.....
            </p>
          </div>
        </div>
        <div className="notification_div">
          <div style={{ marginTop: "10px" }}>
            <p className="notification_mainTitle">Notification 1</p>
            <p className="notification_subtitle">
              This is the dummy notification.....
            </p>
          </div>
        </div>
        <div className="notification_div">
          <div style={{ marginTop: "10px" }}>
            <p className="notification_mainTitle">Notification 1</p>
            <p className="notification_subtitle">
              This is the dummy notification.....
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Notification;
